import React, { useState } from "react";
import { Link } from "react-router-dom";
import './styles.scss';
import AccountInfoTab from "./AccountInfoTab";
import SetPassword from "./SetPassword";
import Infomation from "./Infomation";
import BankInfoTab from "./BankInfoTab";
import DeliveryAddressTab from "./DeliveryAddressTab";
import InvoiceInfomation from "./InvoiceInfomation";

export default function MyAccount() {
    const searchParams = new URLSearchParams(window.location.search);
    const tab = searchParams.get('tab');

    React.useEffect(() => {
        const tabMap: { [key: string]: number } = {
            my_info: 1,
            password: 2,
            business_info: 3,
            bank_info: 4,
            invoice_info: 5,
            delivery_info: 6,
        };
        if (tab && tabMap[tab as string]) {
            setActiveTab(tabMap[tab as string]);
        }
    }, [tab]);
    const [activeTab, setActiveTab] = useState(1);
    const tabs = [
        { id: 1, label: "Thông tin tài khoản" },
        { id: 2, label: "Đặt mật khẩu" },
        { id: 3, label: "Thông tin doanh nghiệp" },
        { id: 4, label: "Tài khoản ngân hàng" },
        { id: 5, label: "Thông tin xuất hoá đơn" },
        { id: 6, label: "Thông tin giao hàng" },
    ];

    return (
        <div className="MuiGrid-root MuiGrid-container MuiGrid-direction-xs-column">
            <header className="MuiPaper-root MuiAppBar-root MuiAppBar-positionFixed MuiAppBar-colorPrimary styles_appBar__Kzodx mui-fixed MuiPaper-elevation4 w-full-1199-24px show-1199">
                <div className="MuiToolbar-root MuiToolbar-regular styles_toolBar__DQTee MuiToolbar-gutters">
                    <Link to="/" className="MuiButtonBase-root MuiButton-root MuiButton-text styles_btnHamburger__POqzB" aria-label="back pagehome">
                        <span className="MuiButton-label">
                            <span style={{ boxSizing: "border-box", display: "inline-block", overflow: "hidden", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", position: "relative", maxWidth: "100%" }}>
                                <span style={{ boxSizing: "border-box", display: "block", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", maxWidth: "100%" }}>
                                    <img alt="" aria-hidden="true" src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2724%27%20height=%2724%27/%3e" style={{ display: "block", maxWidth: "100%", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px" }} />
                                </span>
                                <img src="https://cdn-web-mobile-next.thuocsi.vn/images/header-v2/arrow-left.svg" decoding="async" data-nimg="intrinsic" style={{ position: "absolute", inset: "0px", boxSizing: "border-box", padding: "0px", border: "none", margin: "auto", display: "block", width: "0px", height: "0px", minWidth: "100%", maxWidth: "100%", minHeight: "100%", maxHeight: "100%" }} />
                            </span>
                        </span>
                        <span className="MuiTouchRipple-root"></span>
                    </Link>
                    <p className="MuiTypography-root styles_formTitle__o8AZx MuiTypography-body1">Tài khoản của tôi</p>
                </div>
            </header>
            <div className="MuiPaper-root styles_wrapper___jlVO MuiPaper-elevation1 MuiPaper-rounded show-1199-pt-50px">
                <div className="MuiTabs-root">
                    <div
                        className="MuiTabs-scroller MuiTabs-scrollable"
                        style={{ marginBottom: "0px" }}
                    >
                        <div
                            aria-label="product details tabs"
                            className="MuiTabs-flexContainer"
                            role="tablist"
                        >
                            {tabs.map((tab) => (
                                <button
                                    key={tab.id}
                                    className={`active-tab MuiButtonBase-root MuiTab-root styles_tab__RC4JS MuiTab-textColorInherit ${activeTab === tab.id ? "Mui-selected" : ""
                                        }`}
                                    tabIndex={activeTab === tab.id ? 0 : -1}
                                    type="button"
                                    role="tab"
                                    aria-selected={activeTab === tab.id}
                                    aria-controls={`mui-p-91529-P-${tab.id}`}
                                    id={`mui-p-91529-T-${tab.id}`}
                                    onClick={() => setActiveTab(tab.id)}
                                >
                                    <span className="MuiTab-wrapper">{tab.label}</span>
                                </button>
                            ))}
                        </div>
                    </div>
                </div>

                {activeTab === 1 && (
                    <AccountInfoTab />
                )}
                {activeTab === 2 && (
                    <SetPassword />
                )}
                {activeTab === 3 && (
                    <Infomation />
                )}
                {activeTab === 4 && (
                    <BankInfoTab />
                )}
                {activeTab === 5 && (
                    <InvoiceInfomation />
                )}
                {activeTab === 6 && (
                    <DeliveryAddressTab />
                )}
            </div>
        </div>
    );
}
